import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navItems = [
  { label: '动画首页', to: '/' },
  { label: '剧集分类', to: '/category' },
  { label: '搜索', to: '/search' },
  { label: '关于', to: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-3 py-2 text-sm font-medium transition-colors duration-200 ${
      isActive ? 'text-accent-400' : 'text-foreground-200 hover:text-foreground-50'
    }`;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? 'bg-background-950/90 backdrop-blur-md border-b border-primary-900/40'
          : 'bg-gradient-to-b from-background-950/80 to-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <span className="w-9 h-9 rounded-full bg-gradient-to-br from-primary-500 to-secondary-500 flex items-center justify-center text-background-50">
            <i className="ri-moon-clear-fill text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading font-bold text-base tracking-wide text-foreground-50 group-hover:text-accent-400 transition-colors">
              无颜之月
            </span>
            <span className="text-[10px] tracking-[0.25em] text-foreground-400 uppercase">Season One</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 absolute left-1/2 -translate-x-1/2">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/search"
            className="hidden md:flex items-center gap-2 rounded-full bg-primary-500/15 border border-primary-500/30 px-4 py-2 text-sm text-foreground-100 hover:bg-primary-500/25 transition-colors whitespace-nowrap"
          >
            <i className="ri-search-line"></i>
            <span>查找剧集</span>
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-800/70 border border-primary-900/40 text-foreground-100 cursor-pointer"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-3-line text-xl'}></i>
          </button>
        </div>
      </div>

      <div className="md:hidden">
        {menuOpen && (
          <div className="border-t border-primary-900/40 bg-background-950/98 backdrop-blur-md px-4 py-4">
            <nav className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  className={({ isActive }) =>
                    `flex items-center justify-between rounded-lg px-4 py-3 text-base transition-colors ${
                      isActive
                        ? 'bg-primary-500/20 text-accent-400'
                        : 'text-foreground-100 hover:bg-background-800/70'
                    }`
                  }
                >
                  <span>{item.label}</span>
                  <i className="ri-arrow-right-s-line"></i>
                </NavLink>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}